(function($){
    'use strict';
    $(document).ready(function () {
        $('.browse-tabs .tabs__tab-list').slick('unslick');

    });

}(jQuery));